/**
 * Permission Naming Conventions:
 *
 * CanAccess* - PLAN-BASED permissions (applies to all users in a company)
 *   - Checks if the company's subscription plan includes access to a feature
 *   - Examples: CanAccessAnnouncements, CanAccessAwards, CanAccessAnalytics
 *
 * CanAdminister* - ROLE-BASED permissions (applies to specific users)
 *   - Checks if the user has specific admin role(s)
 *   - Examples: CanAdministerAnnouncements, CanAdministerAwards
 *
 * Usage Pattern:
 *   For admin functionality, explicitly check BOTH:
 *   usePermission(Permission.CanAccessFeature) && usePermission(Permission.CanAdministerFeature)
 *
 *   This makes dual authorization requirements clear and prevents obfuscation.
 */
export enum Permission {
	// home
	CanGiveRecognition = 'can-give-recognition',
	CanAccessUserProfile = 'can-access-user-profile',
	CanAccessAnnouncements = 'can-access-announcements',
	CanAdministerAnnouncements = 'can-administer-announcements',
	CanAccessUserSavedFeeds = 'can-access-user-saved-feeds',

	// sidebar
	CanViewStrongerConnections = 'can-view-stronger-connections',
	CanViewManagerGiving = 'can-view-manager-giving',

	// sidebar
	CanViewHashtagSummary = 'can-view-hashtag-summary',
	CanViewUserSummary = 'can-view-user-summary',

	// rewards
	CanClaimPointsBoost = 'can-claim-points-boost',

	// admin
	CanViewAdmin = 'can-view-admin',
	CanAccessAdminOnlySettings = 'can-access-admin-only-settings',
	CanManageAwards = 'can-manage-awards',
	CanManagePointsBoost = 'can-manage-points-boost',
	CanManageShowDepartmentsOnLeaderboard = 'can-manage-show-departments-on-leaderboard',
	CanViewContinuousCheckIns = 'can-view-continuous-check-ins',
	CanAccessUserManagement = 'can-access-user-management',
	CanManageUserImport = 'can-manage-user-import',
	CanViewPointsReports = 'can-view-points-reports',

	// super admin
	CanViewSuperAdmin = 'can-view-super-admin',

	// admin programs
	CanAccessAnalytics = 'can-access-analytics',
	CanManagePeerToPeer = 'can-manage-peer-to-peer',

	// Growth features
	CanAccessOneOnOnes = 'can-access-one-on-ones',
	CanAccessRecaps = 'can-access-recaps',
	CanAccessAdvice = 'can-access-advice',
	CanAccessGoals = 'can-access-goals', // Covers both individual Goals and Company Initiatives (company-level goals)

	// Top-down recognition features
	CanAccessAwards = 'can-access-awards',
	CanAccessNominations = 'can-access-nominations',
	CanAccessIncentives = 'can-access-incentives',
	CanAccessFlashPoints = 'can-access-flash-points',

	// Check-in
	CanAccessCheckIn = 'can-access-check-in',
	CanAccessAdminCheckInControls = 'can-access-admin-check-in-controls',

	// Manager
	CanAccessTeamHub = 'can-access-team-hub',

	// Video
	CanManageVideoUploads = 'can-manage-video-uploads',
	CanRecordVideo = 'can-record-video',
	CanAccessVideoCarousel = 'can-access-video-carousel',
}
